 
 import moment from "moment";
 import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
 export const PurchaseOrderPreview = ({formValues, viewMode}) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
    const calculateItemTotal = (item) => {
        return (
          Number("500") +
          Number("250") * Number(viewMode? item?.shortVideosEligible : item?.storyType?.shortEligibleCount)
        );
      };
      const getFormattedPublishDate = (phases) => {
        const publishPhase = phases?.find(phase => phase.name === "PUBLISH");
        return publishPhase ? moment(publishPhase.endDate).format("DD.MM.YYYY") : "N/A";
    };
    
      const calculateTotal = (items) => {
        return items?.reduce((total, item) => total + calculateItemTotal(item), 0);
      };
      const handleCreateInvoice = async() => {
        try{
          setLoading(true);
          const formattedData = {
            seller: "Aditya Chaudhary",
            buyer: "INZINT Private Limited",
            orderDate: moment.now(),
            dueDate: moment().endOf("month").format("LL"),
            items: formValues?.map((item) => ({
                videoId: item?._id,
                shortVideosEligible: item?.storyType?.shortEligibleCount,
                mainVideoRate: 500,
                shortVideoRate: 250,



            })),
            status: "PENDING",

          };
          await axios.post(
            `${process.env.REACT_APP_API_URL}/create-purchase-order`,
            formattedData,
            {
              withCredentials: true,
            },
          );
        setLoading(false);
        navigate("/videos");
        

        }
        catch(err){
          console.log(err)
        }
        
      }
    
 return (
 <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6">
                <div className="flex justify-between mb-6 border-b pb-4">
                  <h1 className="text-2xl font-bold text-gray-800">
                    Purchase Order Preview
                  </h1>
                
                </div>

                <div className="space-y-6">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <p className="font-medium text-gray-700">Seller:</p>
                      <p className="mt-1">
                       {formValues?.seller ||  "Aditya Chaudhary"} 
                      </p>
                    </div>
                    <div>
                      <p className="font-medium text-gray-700">Buyer:</p>
                      <p className="mt-1">INZINT Private Limited</p>
                    </div>
                    <div>
                      <p className="font-medium text-gray-700">Order Date:</p>
                      <p className="mt-1">
                        {moment(formValues?.orderDate).format("LL")}
                      </p>
                    </div>
                    <div>
                      <p className="font-medium text-gray-700">
                        Delivery Due Date:
                      </p>
                      <p className="mt-1">
                      {viewMode ? moment(formValues?.dueDate).format("LL") : moment().endOf("month").format("LL")} by 5pm

                      </p>
                    </div>
                  </div>
                  <p>The company intends to acquire a diverse range of high-quality, engaging content from the aforementioned seller to enhance
                  its digital presence across YouTube, LinkedIn, and Instagram.</p>

                  <table className="w-full border-collapse mt-6">
                    <thead>
                      <p className="flex w-max">Items Ordered:</p>
                      <tr className="bg-gray-50">
                        <th className="border p-2 text-left font-medium text-gray-700">
                          Sr. No
                        </th>
                        <th className="border p-2 text-left font-medium text-gray-700">
                          Item Description/Title
                        </th>
                        <th className="border p-2 text-left font-medium text-gray-700">
                          Style
                        </th>
                        <th className="border p-2 text-left font-medium text-gray-700">
                          Expected Publishing Date
                        </th>
                        <th className="border p-2 text-left font-medium text-gray-700">
                          Min. length(in minutes)
                        </th>
                        
                        <th className="border p-2 text-right font-medium text-gray-700">
                          Main Video Rate (₹)
                        </th>
                        <th className="border p-2 text-right font-medium text-gray-700">
                          Short Video Rate (₹)
                        </th>
                        <th className="border p-2 text-right font-medium text-gray-700">
                          Short Videos Eligible
                        </th>
                        <th className="border p-2 text-right font-medium text-gray-700">
                          Total (₹)
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                    {(viewMode ? formValues?.items : formValues)?.map((item, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="border p-2">{index + 1}</td>
                          <td className="border p-2">
                            {viewMode ? item?.videoId.topic : item?.topic}
                          </td>
                          <td className="border p-2">
                            {viewMode ? item?.videoId.videoStyle?.name : item?.videoStyle?.name}
                          </td>
                        
                            <td className="border p-2">
                            {getFormattedPublishDate(viewMode ? item?.videoId.phases :  item?.phases)}


    </td>
    <td className="border p-2 items-center">
                            {viewMode ? item?.videoId.storyType?.durationRange : item?.storyType?.durationRange}


    </td>
                          <td className="border p-2 text-right">
                          ₹500
                          </td>
                          <td className="border p-2 text-right">
                            ₹250
                          </td>
                          <td className="border p-2 text-right">
                          {viewMode ? item?.shortVideosEligible : item?.storyType?.shortEligibleCount}
                          </td>
                          <td className="border p-2 text-right">
                            {calculateItemTotal(item)}
                          </td>
                        </tr>
                      ))}
                      <tr className="font-bold bg-gray-50">
                        <td colSpan={8} className="border p-2 text-right">
                          Est. Total:
                        </td>
                        <td className="border p-2 text-right">
                        ₹{viewMode ? formValues?.totalAmount : calculateTotal(formValues)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {/* <p>Total Cost of the Purchase: <u><b>₹{calculateTotal(formValues.items)}</b></u>, plus a performance-based bonus of the same amount.</p> */}

<p className="font-bold">Most Important Terms & Conditions:</p>
<ol>
    <li><b>1. Videos under 90 seconds:</b> Must be published on the company's Instagram, YouTube, and LinkedIn handles.</li>
    <li><b>2. Videos above 90 seconds but less than 10 minutes:</b> Must be published on the company's YouTube and LinkedIn handles only.</li>
    <li><b>3. Videos above 10 minutes:</b> Must be published only on the company's YouTube handle.</li>
    <li><b>4. Primary Performance Metric:</b> YouTube will serve as the primary platform for measuring the performance of a video.</li>
    <li>
        <b>5. Acceptance Criteria:</b>
        <ol type="a">
            <li><b>a. Videos under 90 seconds:</b> Eligible for payment only after achieving at least 400 views within the first 7 days.</li>
            <li><b>b. Videos above 90 seconds:</b> Eligible for payment only after achieving at least 200 views within the first 7 days.</li>
        </ol>
    </li>
    <li><b>6. Bonus Eligibility:</b> Videos exceeding the acceptance criteria will qualify for a bonus. For every additional 25% views beyond the acceptance threshold, the video will earn 25% of the bonus amount, up to a maximum bonus of 100%.</li>
    <li><b>7. Delivery Cutoff Date:</b> All deliverables must be submitted by the specified delivery cutoff date.</li>
    <li>
        <b>8. Non-Delivery & Penalty:</b> 
        Non-delivery includes missing the deadline, shifting delivery to the following month, or any delays beyond the cutoff date. For each undelivered or delayed item, a penalty of 50% of the payment for that item will be applied. This penalty will be deducted from the total earnings of the seller.
    </li>
    <li><b>9. Deductions:</b> A 2% TDS will be deducted from the final payment.</li>
    <li><b>10. Team Collaboration:</b> Content production is a collaborative effort. The consultant is responsible for task delegation, ensuring alignment, and coordinating with team members to meet delivery goals and prevent non-delivery.</li>
    <li>
        <b>11. Special Requirement for Podcast:</b> 
        The consultant must:
        <ul>
            <li>Organize, shortlist, and finalize a guest.</li>
            <li>Handle logistics, oversee recording, editing, and publishing.</li>
            <li>Coordinate across departments, ensuring proper planning, delegation, and execution.</li>
        </ul>
    </li>
</ol>

                </div>
                
              { !viewMode &&<button  onClick={handleCreateInvoice}
              disabled={loading}
              className="px-4 py-2 mt-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 shadow-sm transition-colors">{loading ? "Submitting..." : "Submit"}</button>}

              </div>
 );
};